import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { RouteComponentProps } from 'react-router-dom';
import { IRootState } from 'src/reducers';
import { actionCreators as authActionCreators } from 'src/reducers/Auth';

import './Forbidden.scss';

interface IForbiddenProps extends RouteComponentProps {
  pushPage: (path: string) => void;
  logoutUser: () => void;
}

const Forbidden: React.FC<IForbiddenProps> = ({ pushPage, logoutUser }) => {

  useEffect(() => {
    const timer = setTimeout(() => {
      // Logout the user
      logoutUser();
      // Redirect to /login
      pushPage('/login');
    }, 2500); // delay 2.4 seconds

    return () => clearTimeout(timer);
  }, [logoutUser, pushPage]);

  return (
    <div className="forbidden-page">
      <div className="forbidden-content">
        <h1 className="forbidden-code">403</h1>
        <h2 className="forbidden-title">Access Denied</h2>
        <p className="forbidden-message">
          You don’t have permission to access this page.
          <br />
          Please contact your administrator if you believe this is an error.
          <br />
          You will be automatically logged out.
        </p>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  pushPage: push,
  logoutUser: authActionCreators.logout,
};

export default connect<null, typeof mapDispatchToProps, {}, IRootState>(
  null,
  mapDispatchToProps
)(Forbidden);


// WEBPACK FOOTER //
// ./src/components/common/AccessDeniedPage.tsx